import React, { useEffect } from "react"

import { Form, Input, Label, Row, Col, FormFeedback, Alert } from "reactstrap"

import { useFormik } from "formik"
import * as Yup from "yup"
import { useUpdateIcdAgreementDetailsMutation } from "store/api/kyc/kyc"
import Spinners from "components/Common/Spinner"
import toast from "react-hot-toast"
import {
  formatAmount,
  formatAmountInWords,
  sanitizeIntegerInput,
} from "helpers/common"
import KYCPrevButton from "./kycPrevButton"
import { useResolveIcdAgreementOnboardedInvestorMutation } from "store/api/wealthpartnerapi/onboardResolve.api"

const defaultValues = {
  tenure: "36",
  amount: "",
}
const AgreementDetails = ({ kycData, currentStep }) => {
  const [updateData, { isLoading }] =
    useResolveIcdAgreementOnboardedInvestorMutation()

  const validation = useFormik({
    initialValues: { ...defaultValues },
    validationSchema: Yup.object({}),
    validateOnMount: false,
    onSubmit: async (values) => {
      onFormUpdate(values)
    },
  })

  useEffect(() => {
    const item =
      kycData?.icdAgreements.length > 0 ? kycData?.icdAgreements[0] : null

    validation.setValues({
      tenure: item?.tenure || "36",
      amount: item?.amount || "",
    })
  }, [kycData])

  const onFormUpdate = async (values) => {
    try {
      const { data, message, success } = await updateData({
        ...values,
        id: kycData.id,
      }).unwrap()
      if (success) {
        toast.success(message, { id: "toastMessage" })
        window.location.reload()
      }
    } catch (error) {
      const data = error?.data
      if (data?.errors) {
        const { errors } = data
        validation.setErrors(errors)
      }
      toast.error(error?.data?.message, { id: "toastMessage" })
    }
  }

  return (
    <>
      <div className="bank-details-wrapper">
        <h5 className="title mb-3">Agreement Details </h5>
        <Form
          onSubmit={(e) => {
            e.preventDefault()
            validation.handleSubmit()
            return false
          }}
        >
          <Row className="mb-2">
            <Col xl={12}>
              <Label className="col-form-label">
                ICD Tenure (in Months)<span className="error">*</span>
              </Label>
              <Input
                disabled
                name="tenure"
                type="number"
                className="form-control"
                placeholder="Tenure"
                min={1}
                value={validation.values.tenure}
                onChange={validation.handleChange}
                onBlur={validation.handleBlur}
                invalid={
                  validation.touched.tenure && validation.errors.tenure
                    ? true
                    : false
                }
              />

              {validation.touched.tenure && validation.errors.tenure ? (
                <FormFeedback type="invalid">
                  {validation.errors.tenure}
                </FormFeedback>
              ) : null}
            </Col>
            <Col xl={12}>
              <Label className="col-form-label">
                Proposed ICD Amount <span className="error">*</span>
              </Label>

              <Input
                name="amount"
                type="text"
                className="form-control"
                placeholder="Proposed ICD Amount"
                min={1}
                value={`₹ ${formatAmount(validation.values.amount)}`}
                onChange={(e) =>
                  sanitizeIntegerInput(e, validation.setFieldValue, "amount")
                }
                invalid={
                  validation.touched.amount && validation.errors.amount
                    ? true
                    : false
                }
              />
              <p
                className="text-dark"
                style={{ textAlign: "start", marginTop: "10px" }}
              >
                Indian Rupees{" "}
                {formatAmountInWords(validation.values.amount || 0)} Only
              </p>
              <span
                className="text-muted"
                style={{
                  fontStyle: "italic",
                }}
              >
                The Proposed ICD Amount is a non-binding indicative limit and
                does not create any obligation to invest in Prachay Capital
                Limited.
              </span>
              {validation.touched.amount && validation.errors.amount ? (
                <FormFeedback type="invalid">
                  {validation.errors.amount}
                </FormFeedback>
              ) : null}
            </Col>

            <Col sm={12}>
              <Row className="mt-4">
                <KYCPrevButton
                  kycData={kycData}
                  currentStep={currentStep}
                  disabled={isLoading}
                  ButtonHtml={
                    <button type="submit" className="btn btn-primary w-100">
                      {isLoading ? <Spinners /> : "Save & Next"}
                    </button>
                  }
                />
              </Row>
            </Col>
          </Row>
        </Form>
      </div>
    </>
  )
}

export default AgreementDetails
